/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Bell_Activity_Lines_ManyInputs */

const en_bell_activity_lines_many = /** @type {(inputs: Bell_Activity_Lines_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lines changed`)
};

/**
* | output |
* | --- |
* | "{count} lines changed" |
*
* @param {Bell_Activity_Lines_ManyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_lines_many = /** @type {((inputs: Bell_Activity_Lines_ManyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Lines_ManyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_lines_many(inputs)
});